
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("3WBvo", function(module, exports) {

$parcel$export(module.exports, "AtlassianNavigation", () => $94b090d23aea3a67$export$f66ccb39f60980e5);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $3jLHL = parcelRequire("3jLHL");

var $ffCOo = parcelRequire("ffCOo");

var $6fnsQ = parcelRequire("6fnsQ");

var $2yFMK = parcelRequire("2yFMK");

var $ahT8g = parcelRequire("ahT8g");
var $8K0Og = parcelRequire("8K0Og");

var $aganF = parcelRequire("aganF");
const $94b090d23aea3a67$var$containerStyles = (0, $3jLHL.css)({
    display: 'flex',
    boxSizing: 'border-box',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    height: (0, $2yFMK.HORIZONTAL_GLOBAL_NAV_HEIGHT),
    position: 'relative',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexShrink: 0,
    borderBlockEnd: `1px solid ${`var(--ds-border, ${(0, $6fnsQ.N30)})`}`,
    paddingInlineEnd: "var(--ds-space-150, 12px)",
    paddingInlineStart: "var(--ds-space-150, 12px)"
});
const $94b090d23aea3a67$var$leftStyles = (0, $3jLHL.css)({
    display: 'flex',
    minWidth: 0,
    height: 'inherit',
    alignItems: 'center',
    flexGrow: 1,
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& > *': {
        flexShrink: 0
    }
});
const $94b090d23aea3a67$var$rightStyles = (0, $3jLHL.css)({
    display: 'flex',
    alignItems: 'center',
    flexShrink: 0,
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& > *': {
        flexShrink: 0,
        marginInlineEnd: "var(--ds-space-050, 4px)"
    }
});
const $94b090d23aea3a67$var$noRightMarginStyles = (0, $3jLHL.css)({
    marginInlineEnd: 0
});
const $94b090d23aea3a67$var$analyticsData = {
    attributes: {
        navigationLayer: 'global'
    },
    componentName: 'atlassianNavigation'
};
const $94b090d23aea3a67$export$f66ccb39f60980e5 = (props)=>{
    const { label: label, primaryItems: primaryItems = [], renderAppSwitcher: AppSwitcher, renderCreate: create, renderHelp: Help, renderNotifications: Notifications, renderProductHome: ProductHome, renderProfile: Profile, renderSearch: Search, renderSignIn: SignIn, renderSettings: Settings, moreLabel: moreLabel = "\u2026", theme: theme = (0, $ahT8g.defaultTheme), testId: testId, isServer: isServer = false, isSSRPlaceholderEnabled: isSSRPlaceholderEnabled = false } = props;
    return /*#__PURE__*/ (0, $3jLHL.jsx)((0, $8K0Og.ThemeProvider), {
        value: theme
    }, /*#__PURE__*/ (0, $3jLHL.jsx)((0, $ffCOo.NavigationAnalyticsContext), {
        data: $94b090d23aea3a67$var$analyticsData
    }, /*#__PURE__*/ (0, $3jLHL.jsx)("header", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: theme.mode.navigation,
        css: $94b090d23aea3a67$var$containerStyles,
        "data-testid": testId && `${testId}-header`,
        role: "banner",
        "data-vc": `atlassian-navigation${isServer ? '-ssr' : ''}`,
        ...isServer && isSSRPlaceholderEnabled && {
            'data-ssr-placeholder': 'atlassian-navigation-placeholder'
        },
        ...!isServer && isSSRPlaceholderEnabled && {
            'data-ssr-placeholder-replace': 'atlassian-navigation-placeholder'
        }
    }, /*#__PURE__*/ (0, $3jLHL.jsx)("nav", {
        css: $94b090d23aea3a67$var$leftStyles,
        "aria-label": label
    }, AppSwitcher && /*#__PURE__*/ (0, $3jLHL.jsx)(AppSwitcher, null), ProductHome && /*#__PURE__*/ (0, $3jLHL.jsx)(ProductHome, null), /*#__PURE__*/ (0, $3jLHL.jsx)((0, $aganF.PrimaryItemsContainer), {
        testId: testId,
        moreLabel: moreLabel,
        items: primaryItems,
        create: create,
        // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides
        theme: theme
    })), /*#__PURE__*/ (0, $3jLHL.jsx)("div", {
        css: $94b090d23aea3a67$var$rightStyles,
        "data-testid": testId && `${testId}-secondary-actions`
    }, Search && /*#__PURE__*/ (0, $3jLHL.jsx)(Search, null), /*#__PURE__*/ (0, $3jLHL.jsx)("div", {
        role: "list",
        css: [
            $94b090d23aea3a67$var$rightStyles,
            $94b090d23aea3a67$var$noRightMarginStyles
        ],
        "data-vc": "atlassian-navigation-secondary-actions"
    }, Notifications && /*#__PURE__*/ (0, $3jLHL.jsx)(Notifications, null), Help && /*#__PURE__*/ (0, $3jLHL.jsx)(Help, null), Settings && /*#__PURE__*/ (0, $3jLHL.jsx)(Settings, null), SignIn && /*#__PURE__*/ (0, $3jLHL.jsx)(SignIn, null), Profile && /*#__PURE__*/ (0, $3jLHL.jsx)(Profile, null))))));
};

});
parcelRegister("aganF", function(module, exports) {

$parcel$export(module.exports, "PrimaryItemsContainer", () => $01492386bf7342dd$export$43e704064d596a9e);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $gwFzn = parcelRequire("gwFzn");

var $3jLHL = parcelRequire("3jLHL");

var $lGgRw = parcelRequire("lGgRw");

var $6fnsQ = parcelRequire("6fnsQ");

var $4JDbp = parcelRequire("4JDbp");

var $aJmpt = parcelRequire("aJmpt");

var $dhlon = parcelRequire("dhlon");
const $01492386bf7342dd$var$containerStyles = (0, $3jLHL.css)({
    display: 'flex',
    height: '100%',
    position: 'relative',
    alignItems: 'stretch',
    flexBasis: 0,
    flexGrow: 1,
    flexShrink: 0,
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& > *': {
        margin: `0 ${"var(--ds-space-050, 4px)"}`,
        flexShrink: 0
    }
});
const $01492386bf7342dd$var$widthObserverContainerStyles = (0, $3jLHL.css)({
    width: '100%',
    minWidth: '1px',
    margin: '0px',
    position: 'relative',
    flexShrink: 1
});
const $01492386bf7342dd$var$overflowItemsStyles = (0, $3jLHL.css)({
    color: `var(--ds-text, ${(0, $6fnsQ.N700)})`
});
const $01492386bf7342dd$export$43e704064d596a9e = ({ moreLabel: moreLabel, items: items, create: Create, theme: theme, testId: testId })=>{
    const [isMoreOpen, setIsMoreOpen] = (0, $gwFzn.useState)(false);
    const { updateWidth: updateWidth, visibleItems: visibleItems, overflowItems: overflowItems } = (0, $aJmpt.useOverflowController)(items);
    const onMoreClick = (0, $gwFzn.useCallback)(()=>{
        setIsMoreOpen(!isMoreOpen);
    }, [
        isMoreOpen,
        setIsMoreOpen
    ]);
    const onMoreClose = (0, $gwFzn.useCallback)(()=>{
        setIsMoreOpen(false);
    }, []);
    const openOverflowMenu = (0, $gwFzn.useCallback)(()=>{
        setIsMoreOpen(true);
    }, []);
    const trigger = (0, $gwFzn.useCallback)((triggerProps)=>/*#__PURE__*/ (0, $3jLHL.jsx)((0, $dhlon.PrimaryDropdownButton), {
            onClick: onMoreClick,
            isSelected: isMoreOpen,
            testId: testId ? `${testId}-overflow-menu-trigger` : 'overflow-menu-trigger',
            ...triggerProps
        }, moreLabel), [
        moreLabel,
        onMoreClick,
        isMoreOpen,
        testId
    ]);
    const content = (0, $gwFzn.useCallback)(()=>/*#__PURE__*/ (0, $3jLHL.jsx)((0, $aJmpt.OverflowProvider), {
            isVisible: false,
            openOverflowMenu: openOverflowMenu,
            closeOverflowMenu: onMoreClose
        }, /*#__PURE__*/ (0, $3jLHL.jsx)("div", {
            css: $01492386bf7342dd$var$overflowItemsStyles
        }, overflowItems)), // Overflow items has an unstable reference - so we will only recalculate
    // content if `overflowItems` length changes.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        overflowItems.length,
        openOverflowMenu,
        onMoreClose
    ]);
    return /*#__PURE__*/ (0, $3jLHL.jsx)("div", {
        css: $01492386bf7342dd$var$containerStyles,
        "data-testid": testId && `${testId}-primary-actions`,
        role: "list"
    }, /*#__PURE__*/ (0, $3jLHL.jsx)((0, $aJmpt.OverflowProvider), {
        isVisible: true,
        openOverflowMenu: openOverflowMenu,
        closeOverflowMenu: onMoreClose
    }, visibleItems), overflowItems.length > 0 && /*#__PURE__*/ (0, $3jLHL.jsx)((0, $lGgRw.default), {
        shouldRenderToParent: true,
        placement: "bottom-start",
        content: content,
        isOpen: isMoreOpen,
        onClose: onMoreClose,
        trigger: trigger,
        testId: testId ? `${testId}-overflow-menu-popup` : 'overflow-menu-popup'
    }), Create && /*#__PURE__*/ (0, $3jLHL.jsx)(Create, null), /*#__PURE__*/ (0, $3jLHL.jsx)("div", {
        css: $01492386bf7342dd$var$widthObserverContainerStyles
    }, /*#__PURE__*/ (0, $3jLHL.jsx)((0, $4JDbp.WidthObserver), {
        offscreen: true,
        setWidth: updateWidth
    })));
};

});
parcelRegister("aJmpt", function(module, exports) {

$parcel$export(module.exports, "OverflowProvider", () => $9e0175bf780b8a15$export$a3a2def3937905a0);
$parcel$export(module.exports, "useOverflowStatus", () => $9e0175bf780b8a15$export$3fcfc71fab3314f2);
$parcel$export(module.exports, "useOverflowController", () => $9e0175bf780b8a15$export$705aa66a39c35bf7);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $eEhUN = parcelRequire("eEhUN");

var $ee7An = parcelRequire("ee7An");
// Prevent width detector from triggering too many re-renders
const $9e0175bf780b8a15$var$THROTTLE_INTERVAL = 64;
// Approx min width of items (based of "More" size)
const $9e0175bf780b8a15$var$ITEM_APPROX_MINWIDTH = 70;
const $9e0175bf780b8a15$var$calculateHash = (w, n)=>w + '#' + n;
const $9e0175bf780b8a15$var$updateHashRef = (currentRef, value)=>{
    currentRef.unshift(value);
    currentRef.length = 3;
};
const $9e0175bf780b8a15$var$OverflowContext = /*#__PURE__*/ (0, $gwFzn.createContext)({
    isVisible: true,
    openOverflowMenu: (0, $ee7An.default),
    closeOverflowMenu: (0, $ee7An.default)
});
const $9e0175bf780b8a15$export$a3a2def3937905a0 = ({ children: children, isVisible: isVisible, openOverflowMenu: openOverflowMenu, closeOverflowMenu: closeOverflowMenu })=>{
    const { Provider: Provider } = $9e0175bf780b8a15$var$OverflowContext;
    const value = (0, $gwFzn.useMemo)(()=>({
            isVisible: isVisible,
            openOverflowMenu: openOverflowMenu,
            closeOverflowMenu: closeOverflowMenu
        }), [
        isVisible,
        openOverflowMenu,
        closeOverflowMenu
    ]);
    return /*#__PURE__*/ (0, $7UHDa.jsx)(Provider, {
        value: value,
        children: children
    });
};
const $9e0175bf780b8a15$export$3fcfc71fab3314f2 = ()=>(0, $gwFzn.useContext)($9e0175bf780b8a15$var$OverflowContext);
const $9e0175bf780b8a15$export$705aa66a39c35bf7 = (nodes)=>{
    const items = (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Children.toArray(nodes);
    const [width, setWidth] = (0, $gwFzn.useState)(9999);
    const [itemsLimit, setItemsLimit] = (0, $gwFzn.useState)(items.length);
    const [forceEffectValue, triggerForceEffect] = (0, $gwFzn.useState)({});
    // Storing items approximate width so we can try expanding when there is enough room
    const itemsWidths = (0, $gwFzn.useRef)([]).current;
    // Storing a couple of width + items count in order to stabilize
    const hashRef = (0, $gwFzn.useRef)([]);
    // AFP-2511 TODO: Fix automatic suppressions below
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const throttleSetWidth = (0, $gwFzn.useCallback)((0, (/*@__PURE__*/$parcel$interopDefault($eEhUN)))(setWidth, $9e0175bf780b8a15$var$THROTTLE_INTERVAL), [
        setWidth
    ]);
    (0, $gwFzn.useEffect)(()=>{
        const lastItemWidth = itemsWidths[itemsLimit] || 0;
        const wasJustLimited = lastItemWidth < 0;
        const currentHash = $9e0175bf780b8a15$var$calculateHash(width, itemsLimit);
        if (hashRef.current[0] === currentHash) {
            // After removing an item, if width has not changed yet we schedule a force update
            // to handle case where removing an item does not actually trigger width change
            const t = setTimeout(()=>{
                $9e0175bf780b8a15$var$updateHashRef(hashRef.current, '');
                triggerForceEffect({});
            }, $9e0175bf780b8a15$var$THROTTLE_INTERVAL * 1.5);
            return ()=>clearTimeout(t);
        }
        if (wasJustLimited) {
            // Width was updated either via resize or after changing the limit
            // we cap the width between ITEM_APPROX_MINWIDTH and 2*ITEM_APPROX_MINWIDTH
            // because width is throttled as when fast expanding/resizing partialWidth
            // will not be reliable (edge case)
            const partialWidth = Math.max(Math.min(width + lastItemWidth, $9e0175bf780b8a15$var$ITEM_APPROX_MINWIDTH * 2), $9e0175bf780b8a15$var$ITEM_APPROX_MINWIDTH);
            itemsWidths[itemsLimit] = partialWidth;
        }
        if (width < $9e0175bf780b8a15$var$ITEM_APPROX_MINWIDTH * 0.9 && itemsLimit) {
            // If current width is less than an item approx width we remove an item
            // marking the width as negative so we will calculate it on width update
            // plus we set the hash to stabilise and not removing more than one element
            // until we are sure width was updated
            const nextHash = $9e0175bf780b8a15$var$calculateHash(width, itemsLimit - 1);
            if (hashRef.current.indexOf(nextHash) === -1) {
                setItemsLimit(itemsLimit - 1);
                itemsWidths[itemsLimit - 1] = -(width || 1);
                $9e0175bf780b8a15$var$updateHashRef(hashRef.current, nextHash);
            }
            return;
        }
        /**
		 * This is not necessarily equal to `lastItemWidth` because the
		 * ```js
		 * if (wasJustLimited) {}
		 * ```
		 * branch above modifies `itemsWidths`.
		 *
		 * Using `lastItemWidth` here can cause collapsing behavior to fail,
		 * such as the issue reported in DSP-7329.
		 */ const currentLastItemWidth = itemsWidths[itemsLimit] || 0;
        if (width - currentLastItemWidth > $9e0175bf780b8a15$var$ITEM_APPROX_MINWIDTH * 1.1 && itemsLimit < items.length) {
            // If we have enough room to accomodate next item width we increase the limit
            // unless it has been recently removed
            const nextHash = $9e0175bf780b8a15$var$calculateHash(width, itemsLimit + 1);
            if (hashRef.current.indexOf(nextHash) === -1) {
                setItemsLimit(itemsLimit + 1);
                $9e0175bf780b8a15$var$updateHashRef(hashRef.current, nextHash);
            }
            return;
        }
    }, [
        width,
        hashRef,
        itemsLimit,
        itemsWidths,
        forceEffectValue,
        items.length
    ]);
    return {
        visibleItems: items.slice(0, itemsLimit),
        overflowItems: items.slice(itemsLimit),
        updateWidth: throttleSetWidth
    };
};
var // Used to extract props for useOverflowStatus();
// eslint-disable-next-line import/no-anonymous-default-export
$9e0175bf780b8a15$export$2e2bcd8739ae039 = (props)=>{};

});

parcelRegister("dhlon", function(module, exports) {

$parcel$export(module.exports, "PrimaryDropdownButton", () => $63edb7eb00cfe676$export$bb3af89fb196520d);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $gwFzn = parcelRequire("gwFzn");

var $3jLHL = parcelRequire("3jLHL");

var $fk6ei = parcelRequire("fk6ei");

var $1NxpI = parcelRequire("1NxpI");
const $63edb7eb00cfe676$export$bb3af89fb196520d = /*#__PURE__*/ (0, $gwFzn.forwardRef)((props, ref)=>{
    const { component: component, isHighlighted: isHighlighted, isLoading: isLoading, onClick: onClick, testId: testId, theme: theme, tooltip: tooltip, ...rest } = props;
    return /*#__PURE__*/ (0, $3jLHL.jsx)((0, $1NxpI.PrimaryButton), {
        component: component,
        iconAfter: /*#__PURE__*/ (0, $3jLHL.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fk6ei))), {
            LEGACY_margin: `0 ${"var(--ds-space-negative-050, -4px)"} 0 ${"var(--ds-space-negative-100, -8px)"}`,
            color: "currentColor",
            label: ""
        }),
        isHighlighted: isHighlighted,
        isLoading: isLoading,
        onClick: onClick,
        ref: ref,
        testId: testId,
        // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides
        theme: theme,
        tooltip: tooltip,
        ...rest
    });
});

});



parcelRegister("6iFTf", function(module, exports) {

$parcel$export(module.exports, "getTag", () => $6fe5f7b36a0a225d$export$dad497fe1f6e27c0);
const $6fe5f7b36a0a225d$export$dad497fe1f6e27c0 = (onClick, href)=>{
    if (href) return 'a';
    if (onClick) return 'button';
    return 'div';
};

});

parcelRegister("heZL9", function(module, exports) {

$parcel$export(module.exports, "default", () => $4bf6d489325cc1fe$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $gwFzn = parcelRequire("gwFzn");

var $3jLHL = parcelRequire("3jLHL");

var $dh538 = parcelRequire("dh538");

var $6fnsQ = parcelRequire("6fnsQ");

var $2yFMK = parcelRequire("2yFMK");

var $4qrTW = parcelRequire("4qrTW");

var $4D5F4 = parcelRequire("4D5F4");

var $6iFTf = parcelRequire("6iFTf");
const $4bf6d489325cc1fe$var$VAR_LOGO_MAX_WIDTH = '--logo-max-width';
const $4bf6d489325cc1fe$var$VAR_PRODUCT_HOME_COLOR_ACTIVE = '--product-home-color-active';
const $4bf6d489325cc1fe$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_ACTIVE = '--product-home-bg-color-active';
const $4bf6d489325cc1fe$var$VAR_PRODUCT_HOME_BOX_SHADOW_ACTIVE = '--product-home-box-shadow-active';
const $4bf6d489325cc1fe$var$VAR_PRODUCT_HOME_COLOR_FOCUS = '--product-home-color-focus';
const $4bf6d489325cc1fe$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_FOCUS = '--product-home-bg-color-focus';
const $4bf6d489325cc1fe$var$VAR_PRODUCT_HOME_BOX_SHADOW_FOCUS = '--product-home-box-shadow-focus';
const $4bf6d489325cc1fe$var$VAR_PRODUCT_HOME_COLOR_HOVER = '--product-home-color-hover';
const $4bf6d489325cc1fe$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_HOVER = '--product-home-bg-color-hover';
const $4bf6d489325cc1fe$var$VAR_PRODUCT_HOME_BOX_SHADOW_HOVER = '--product-home-box-shadow-hover';
const $4bf6d489325cc1fe$var$productHomeButtonStyles = (0, $3jLHL.css)({
    display: 'flex',
    padding: "var(--ds-space-050, 4px)",
    alignItems: 'center',
    background: 'none',
    border: 0,
    borderRadius: "var(--ds-border-radius, 3px)",
    color: 'inherit',
    cursor: 'pointer',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&::-moz-focus-inner': {
        border: 0
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&:first-of-type': {
        marginInlineStart: 0
    },
    '&:hover': {
        backgroundColor: `var(${$4bf6d489325cc1fe$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_HOVER})`,
        boxShadow: `var(${$4bf6d489325cc1fe$var$VAR_PRODUCT_HOME_BOX_SHADOW_HOVER})`,
        color: `var(${$4bf6d489325cc1fe$var$VAR_PRODUCT_HOME_COLOR_HOVER})`
    },
    '&:active': {
        backgroundColor: `var(${$4bf6d489325cc1fe$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_ACTIVE})`,
        boxShadow: `var(${$4bf6d489325cc1fe$var$VAR_PRODUCT_HOME_BOX_SHADOW_ACTIVE})`,
        color: `var(${$4bf6d489325cc1fe$var$VAR_PRODUCT_HOME_COLOR_ACTIVE})`
    },
    '&:focus-visible': {
        backgroundColor: `var(${$4bf6d489325cc1fe$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_FOCUS})`,
        color: `var(${$4bf6d489325cc1fe$var$VAR_PRODUCT_HOME_COLOR_FOCUS})`,
        outline: `${"var(--ds-border-width-outline, 2px)"} solid ${"var(--ds-border-focused, #4C9AFF)"}`
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    'div&': {
        pointerEvents: 'none'
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`@media (max-width: ${(0, $2yFMK.PRODUCT_HOME_BREAKPOINT) - 0.1}px)`]: {
        margin: `0 ${"var(--ds-space-100, 8px)"}`
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`@media (min-width: ${0, $2yFMK.PRODUCT_HOME_BREAKPOINT}px)`]: {
        margin: `0 ${"var(--ds-space-200, 16px)"}`
    }
});
const $4bf6d489325cc1fe$var$productLogoStyles = (0, $3jLHL.css)({
    // Ensure anything passed into
    // productHome is aligned correctly
    display: 'flex',
    maxWidth: `var(${$4bf6d489325cc1fe$var$VAR_LOGO_MAX_WIDTH})`,
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& > *': {
        maxHeight: 24
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& > span > svg': {
        maxWidth: `var(${$4bf6d489325cc1fe$var$VAR_LOGO_MAX_WIDTH})`
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`@media (max-width: ${(0, $2yFMK.PRODUCT_HOME_BREAKPOINT) - 0.1}px)`]: {
        display: 'none'
    }
});
const $4bf6d489325cc1fe$var$customMaxHeightStyles = (0, $3jLHL.css)({
    maxHeight: 28
});
const $4bf6d489325cc1fe$var$productIconStyles = (0, $3jLHL.css)({
    // Ensure anything passed into
    // productHome is aligned correctly
    display: 'flex',
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& > *': {
        maxHeight: 24
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`@media (min-width: ${0, $2yFMK.PRODUCT_HOME_BREAKPOINT}px)`]: {
        display: 'none'
    }
});
const $4bf6d489325cc1fe$var$siteTitleStyles = (0, $3jLHL.css)({
    display: 'flex',
    alignItems: 'center',
    marginInlineEnd: "var(--ds-space-050, 4px)",
    marginInlineStart: "var(--ds-space-050, 4px)",
    paddingInlineEnd: "var(--ds-space-200, 16px)"
});
/**
 * __Product home__
 *
 * The ProductHome component displays the product visual identity composed of:
 * logo, icon, and optional text. Values for logo and icon are never displayed
 * at the same time, where icon is used only when space is restricted. Should be
 * passed into `AtlassianNavigation`'s `renderProductHome` prop.
 *
 * - [Examples](https://atlassian.design/components/atlassian-navigation/examples#product-home)
 * - [Code](https://atlassian.design/components/atlassian-navigation/code)
 */ const $4bf6d489325cc1fe$var$ProductHome = ({ 'aria-label': ariaLabel, href: href, icon: Icon, logo: Logo, logoMaxWidth: logoMaxWidth = 260, onClick: onClick, onMouseDown: onMouseDown, siteTitle: siteTitle, testId: testId, ...rest })=>{
    const theme = (0, $4qrTW.useTheme)();
    const primaryButton = theme.mode.primaryButton;
    // After the brand refresh, iconColor and textColor should be set to 'undefined' to allow the original
    // multi-color logo tile colors to be visible, rather than a hardcoded blue.
    let { iconColor: iconColor = (0, $dh538.fg)('platform-team25-app-icon-tiles') ? undefined : 'inherit', textColor: textColor = (0, $dh538.fg)('platform-team25-app-icon-tiles') ? undefined : theme.mode.productHome.color } = theme.mode.productHome;
    // The default theme is set at module scope and immediately used in context.
    // To allow the feature flag to switch the logo color at runtime, we also detect the original hardcoded
    // values and override them to undefined.
    if (iconColor === '#357DE8' && textColor === `var(--ds-text, ${0, $6fnsQ.N700})` && (0, $dh538.fg)('platform-team25-app-icon-tiles')) {
        iconColor = undefined;
        textColor = undefined;
    }
    const Tag = (0, $6iFTf.getTag)(onClick, href);
    const preventFocusRing = (e)=>{
        e.preventDefault();
        onMouseDown && onMouseDown(e);
    };
    const productHomeButtonDynamicStyles = (0, $4D5F4.stripEmptyProperties)({
        [$4bf6d489325cc1fe$var$VAR_PRODUCT_HOME_COLOR_ACTIVE]: primaryButton.active.color,
        [$4bf6d489325cc1fe$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_ACTIVE]: primaryButton.active.backgroundColor,
        [$4bf6d489325cc1fe$var$VAR_PRODUCT_HOME_BOX_SHADOW_ACTIVE]: primaryButton.active.boxShadow,
        [$4bf6d489325cc1fe$var$VAR_PRODUCT_HOME_COLOR_FOCUS]: primaryButton.focus.color,
        [$4bf6d489325cc1fe$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_FOCUS]: primaryButton.focus.backgroundColor,
        [$4bf6d489325cc1fe$var$VAR_PRODUCT_HOME_BOX_SHADOW_FOCUS]: primaryButton.focus.boxShadow,
        [$4bf6d489325cc1fe$var$VAR_PRODUCT_HOME_COLOR_HOVER]: primaryButton.hover.color,
        [$4bf6d489325cc1fe$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_HOVER]: primaryButton.hover.backgroundColor,
        [$4bf6d489325cc1fe$var$VAR_PRODUCT_HOME_BOX_SHADOW_HOVER]: primaryButton.hover.boxShadow,
        [$4bf6d489325cc1fe$var$VAR_LOGO_MAX_WIDTH]: `${logoMaxWidth}px`
    });
    return /*#__PURE__*/ (0, $3jLHL.jsx)((0, $gwFzn.Fragment), null, /*#__PURE__*/ (0, $3jLHL.jsx)(Tag, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: productHomeButtonDynamicStyles,
        css: $4bf6d489325cc1fe$var$productHomeButtonStyles,
        href: href,
        onClick: onClick,
        onMouseDown: preventFocusRing,
        "data-testid": testId && `${testId}-container`,
        "aria-label": ariaLabel,
        ...rest
    }, /*#__PURE__*/ (0, $3jLHL.jsx)("div", {
        css: [
            $4bf6d489325cc1fe$var$customMaxHeightStyles,
            $4bf6d489325cc1fe$var$productLogoStyles
        ],
        "data-testid": testId && `${testId}-logo`
    }, /*#__PURE__*/ (0, $3jLHL.jsx)(Logo, {
        iconColor: iconColor,
        textColor: textColor,
        // @ts-ignore - The new icons don't have an appearance prop at the moment
        appearance: (0, $dh538.fg)('platform-team25-app-icon-tiles') ? 'brand' : undefined
    })), /*#__PURE__*/ (0, $3jLHL.jsx)("div", {
        css: [
            $4bf6d489325cc1fe$var$customMaxHeightStyles,
            $4bf6d489325cc1fe$var$productIconStyles
        ],
        "data-testid": testId && `${testId}-icon`
    }, /*#__PURE__*/ (0, $3jLHL.jsx)(Icon, {
        iconColor: iconColor,
        size: (0, $dh538.fg)('platform-team25-app-icon-tiles') ? 'small' : undefined,
        // @ts-ignore - The new icons don't have an appearance prop at the moment
        appearance: (0, $dh538.fg)('platform-team25-app-icon-tiles') ? 'brand' : undefined
    }))), siteTitle && /*#__PURE__*/ (0, $3jLHL.jsx)("div", {
        style: {
            borderRight: theme.mode.productHome.borderRight
        },
        css: $4bf6d489325cc1fe$var$siteTitleStyles,
        "data-testid": testId && `${testId}-site-title`
    }, siteTitle));
};
var $4bf6d489325cc1fe$export$2e2bcd8739ae039 = $4bf6d489325cc1fe$var$ProductHome;

});
parcelRegister("4D5F4", function(module, exports) {

$parcel$export(module.exports, "stripEmptyProperties", () => $4a5bb2f397b22144$export$e03bb5c7fd72635);
/**
 * Returns a new object with only non-empty properties of the input object.
 *
 * In this context, "empty" refers to properties with `null`, `undefined`, or `""`
 * (empty string) values.
 *
 * @param obj - The input object.
 * @returns A new object with non-empty properties of the input object.
 */ function $4a5bb2f397b22144$export$e03bb5c7fd72635(obj) {
    return Object.entries(obj).reduce((acc, [key, value])=>{
        if (value !== null && value !== undefined && value !== '') acc[key] = value;
        return acc;
    }, {});
}

});



//# sourceMappingURL=AppNavigation.67e7a6db.js.map
